import React, {PropsWithChildren} from "react";
import classNames from "classnames";

type ButtonRowType = {
  isFormRow?: boolean
} & PropsWithChildren

export function SVVButtonRow({ isFormRow, children }: ButtonRowType) {
  return (
    <div
      className={classNames(
        "svv-button-row",
        {
          "svv-form-button-row": isFormRow
        }
        )}
    >
      {children}
    </div>
  );
}

SVVButtonRow.displayName = "SVVButtonRow";
